import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { AddMessage, GetConversation, EditMessage, DeleteMessage } from '../../fetchs';

import './conversation.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Conversation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      conversationId: 0,
      title: '',
      senderId: 0,
      priority: 1,
      picUrl: null,
      startDate: '',
      subject: '',
      sender: {},
      messages: [],
      message: '',
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    const conversationId = this.props.match.params.conversationId;
    if (conversationId) {
      this.loadConversation(conversationId);
    }
  }

  loadConversation = (conversationId) => {
    this.setState({ loading: true });
    GetConversation(conversationId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          conversationId: responseJson.conversationId,
          title: responseJson.title,
          priority: responseJson.priority,
          picUrl: responseJson.picUrl,
          startDate: responseJson.startDate,
          subject: responseJson.subject.title,
          senderId: responseJson.senderId,
          sender: responseJson.sender,
          messages: responseJson.messages,
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSend = () => {
    if (this.state.message) {
      AddMessage({
        text: this.state.message,
        conversationId: this.state.conversationId
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.setState({ message: '' });
          this.loadConversation(this.state.conversationId);
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              مشاهده مکالمه
            </Typography>
            <Grid container>
              <Grid item md={7}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-title"
                          label="عنوان"
                          fullWidth
                          disabled
                          className="disabled"
                          value={this.state.title}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-priority"
                          label="اولویت"
                          fullWidth
                          disabled
                          className="disabled"
                          value={this.state.priority}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-start-date"
                          label="تاریخ"
                          fullWidth
                          disabled
                          className="disabled"
                          value={this.state.startDate}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-subject"
                          label="موضوع"
                          fullWidth
                          disabled
                          className="disabled"
                          value={this.state.subject}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-sender"
                          label="فرستنده"
                          fullWidth
                          disabled
                          className="disabled"
                          value={this.state.sender.firstName + " " + this.state.sender.lastName}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item sx={12}>
                        <img src={`http://adminpanel.zistagram-app.ir/${this.state.picUrl}`} className="fullWidth" alt={this.state.title} />
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
              <Grid item md={5}>
                <Grid item xs={12}>
                  {this.state.messages.map((message, index) => {
                    return (
                      <div className={this.state.senderId === message.senderId ? "senderMessage" : "myMessage"}>
                        <div className="senderName">{message.sender.firstName} {message.sender.lastName}</div>
                        <div className="text">{message.text}</div>
                        <div className="sendDate">{message.sendDate}</div>
                        {/* <div className="isSeen">{message.isSeen ? '1' : '0'}</div> */}
                      </div>
                    )
                  })}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="standard-message"
                    label="پیغام"
                    fullWidth
                    className={classes.TextField}
                    value={this.state.message}
                    onChange={this.handleChange("message")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={this.state.loading}
                    onClick={this.handleSend}>ارسال</Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Conversation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Conversation));
